/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { dailyGetDailyNewsImage } from "../../funcs/dailyGetDailyNewsImage.js";
import { formatResult, ToolDefinition } from "../tools.js";

export const tool$dailyGetDailyNewsImage: ToolDefinition = {
  name: "daily-get-daily-news-image",
  description: `每日新闻图

想用一张图快速了解天下大事？这个接口为你一键生成今日新闻摘要，非常适合用在早报、数字看板或应用首页等场景。

## 功能概述
此接口会实时抓取各大平台的热点新闻，并动态地将它们渲染成一张清晰、美观的摘要图片。你调用接口，直接就能得到一张可以展示的图片。

## 使用须知
调用此接口时，请务必注意以下两点：

1.  **响应格式是图片**：接口成功时直接返回 \`image/jpeg\` 格式的二进制数据，而非 JSON。请确保你的客户端能正确处理二进制流，例如直接在 \`<img>\` 标签中显示，或保存为 \`.jpg\` 文件。

2.  **设置合理超时**：由于涉及实时新闻抓取和图片渲染，处理过程可能耗时数秒。建议将客户端请求超时时间设置为至少10秒，以防止因等待过久而失败。

> [!IMPORTANT]
> 未能正确处理图片响应或超时设置过短，是导致调用失败的最常见原因。`,
  scopes: ["read"],
  annotations: {
    "title": "",
    "destructiveHint": false,
    "idempotentHint": false,
    "openWorldHint": true,
    "readOnlyHint": true,
  },
  tool: async (client, ctx) => {
    const [result] = await dailyGetDailyNewsImage(
      client,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    return formatResult(result.value);
  },
};
